import { Col, Form, FormInstance, Row, Select } from 'antd';
import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
} from '@/components/_common';
import moment from 'moment';
import { CostSalesFormValues } from '@/core/domain/workorder/ManagementCharts/ManagementChart.types';
import { WorkOrderComplementType } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useIntl } from 'react-intl';
import { isAppPortocar } from '@/index';

export enum View {
  totalValue = 'Valor Total',
  quantity = 'Quantidade',
}

interface Props {
  form: FormInstance<CostSalesFormValues>;
}

function SalesCostXSaleForm({ form }: Props) {
  const intl = useIntl();

  return (
    <Form layout="vertical" form={form}>
      <Row gutter={24}>
        <Col span={24}>
          <FloatingFormItem
            name="startDate"
            label={'Data Inicial'}
            initialValue={moment().subtract('months', 1).add('day', 1)}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="endDate"
            label={'Data Final'}
            initialValue={moment()}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem label={'Empresas'} name="companiesIds">
            <CompaniesInfiniteSelectField mode="multiple" allowClear />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            label="Tipos de Orçamento"
            name="types"
            rules={[
              {
                required: true,
                message: 'Selecione pelo menos 1 tipo de orçamento',
              },
            ]}
          >
            <Select
              style={{ width: '100%' }}
              mode="multiple"
              options={[
                {
                  value: WorkOrderComplementType.Courtesy,
                  label: intl.formatMessage({
                    id: `dashboard.averageTicket.modal.form.${
                      isAppPortocar ? 'insideCourtesy' : 'courtesy'
                    }`,
                  }),
                },
                {
                  value: WorkOrderComplementType.Warranty,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.warranty',
                  }),
                },
                {
                  value: WorkOrderComplementType.WorkOrder,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.work_order',
                  }),
                },
                {
                  value: WorkOrderComplementType.TotalLoss,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.total_loss',
                  }),
                },
                {
                  value: WorkOrderComplementType.Return,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.return',
                  }),
                },
                {
                  value: WorkOrderComplementType.Revision,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.revision',
                  }),
                },
              ]}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default SalesCostXSaleForm;
